import React, { useState } from 'react';
import { currencyDisplay, handleAxiosErrors } from '../../_utils';
import ReactLoading from 'react-loading';
import { axiosRemoveProductAppliedDiscountCoupon } from '../../actions/checkoutActions';

function CheckoutDiscountItem(props) {
    const {
        item,
        currencyDisplayCode,
        currencyFormat,
        locale,
        toggleLoading,
    } = props;

    const [isDeleting, setIsDeleting] = useState(false);

    const handleRemoveItem = async (itemID) => {
        let payload = {
            ID: itemID
        }
        toggleLoading('removingCoupon', true);
        setIsDeleting(true);
        return axiosRemoveProductAppliedDiscountCoupon(payload)
            .then((response) => {
                setIsDeleting(false);

                props.requestDetails();
                props.requestCart();
                props.requestDeliveryOptions();

                toggleLoading('removingCoupon', false);
            })
            .catch((error) => {
                handleAxiosErrors(error);
                setIsDeleting(false);
                toggleLoading('removingCoupon', false);
            });
    }

    return (
        <React.Fragment>
            <div className='discount-box' key={item.InternalItemID}>
                <div>
                    <div className='mb-1'>
                        <span>Discount: </span>
                        <span className='underline'>{item.InternalItemID}</span>
                        <span className='text-bold'> {'\u00A0'}- {currencyDisplay(item.Amount, currencyDisplayCode, currencyFormat, locale)}</span>
                    </div>
                    <div>
                        <span>Product: </span>
                        <span>{item.Item.InternalItemID} </span>
                    </div>
                </div>
                <div style={{ position: 'relative' }}>
                    {isDeleting ? (
                        <ReactLoading
                            className='button__spinner'
                            type='spin'
                            color='black'
                            height={20}
                            width={20}
                        />
                    ) : (
                        <span class="icon-close cursor-pointer" onClick={() => handleRemoveItem(item.ID)}></span>
                    )}

                </div>
            </div>
        </React.Fragment >
    );
}

export default CheckoutDiscountItem;
